export const getFeatureFlags = (state) => state.getIn(['config', 'featureFlags']);